<template>
  <div id="app">
    <div class="body_bg">
      <div class="container pd15 whitebg">
        <el-row :gutter="25">
           <!-- <Mlogin/> -->
            <div class="grid-content bg-purple-light">
              <div class="side_con">
                <div class="title_all" style=" margin-bottom: 0;">
                  <div class="title_left">编委会</div>
                  <div class="title_more2"><a href="">首页</a>>编委会</div>
                  <div class="clearfix"></div>
                </div>
                <div class="side_container">
                  <div class="xbjj_con">
                    <table  class="fifth table table-bordered" cellspacing="0" cellpadding="0" width="100%" border="0">
                      <tbody>
                      <tr><th valign="middle" align="center" colspan="2"><p align="center"><strong>2008</strong><strong>年度编委会 </strong></p></th></tr>
                      <tr>
                        <td valign="middle" align="left" colspan="2" class="red"><strong>名誉主任<br></strong></td>
                      </tr>
                      <tr>
                        <td valign="top" align="left" width="12%"><strong>温 学 礼</strong></td>
                        <td valign="top" align="left" width="88%">中国电子元件行业协会理事长、秘书长</td></tr>
                      <tr>
                        <td valign="top" align="left"><strong>黄 建 国</strong></td>
                        <td valign="top" align="left">IEEE西安分会主席</td></tr>
                      <tr>
                        <td valign="middle" align="left" colspan="2" class="red"><strong>主&nbsp;&nbsp;&nbsp;&nbsp;任 </strong></td>
                      </tr>
                      <tr>
                        <td valign="top" align="left"><strong>杨 银 堂</strong></td>
                        <td valign="top" align="left">西安电子科技大学副校长 教授</td></tr>
                      <tr>
                        <td valign="top" align="left"><strong>蔡 苏 昌</strong></td>
                        <td valign="top" align="left">陕西省信息产业厅 副厅长</td></tr>
                      <tr>
                        <td valign="middle" align="left" colspan="2" height="40"><p><strong>特邀顾问</strong></p></td></tr>
                      <tr>
                        <td valign="top" align="left"><strong>沈 绪 榜</strong></td>
                        <td valign="top" align="left">科学院院士 计算机和控制器专家 <br>中国航天时代电子公司第771研究所</td></tr>
                      <tr>
                        <td valign="top" align="left"><strong>邬 江 兴</strong></td>
                        <td valign="top" align="left">工程院院士 通信与信息系统专家 <br>国家数字交换系统工程技术研究中心主任 </td></tr>
                      <tr>
                        <td valign="top" align="left"><strong>马 远 良</strong></td>
                        <td valign="top" align="left">工程院院士 水声处理专家 <br>西北工业大学航空声纳研究发展中心总工程师，中国声学学会副理事长暨水声分会主任 </td></tr>
                      <tr>
                        <td valign="middle" align="left" colspan="2" height="40" class="red"><p><strong>特邀编审</strong><strong> </strong></p></td></tr>
                      <tr>
                        <td valign="top" align="left"><strong>裴 昌 幸</strong></td>
                        <td valign="top" align="left">西安电子科技大学 教授 博导</td></tr>
                      <tr>
                        <td valign="top" align="left"><strong>汉 泽 西</strong></td>
                        <td valign="top" align="left">西安石油大学 教授 硕导</td></tr>
                      <tr>
                        <td valign="top" align="left"><strong>周&nbsp;&nbsp;&nbsp;&nbsp;诠</strong></td>
                        <td valign="top" align="left">中国空间技术研究院西安分院 博导<br></td></tr>
                      <tr>
                        <td valign="middle" align="left"><p><strong>委&nbsp;&nbsp;&nbsp;&nbsp;员</strong><strong> </strong></p></td>
                        <td valign="middle" align="left">（随机排序）</td></tr>
                      <tr>
                        <td valign="top" align="left"><strong>曾 晓 东</strong></td>
                        <td valign="top" align="left">西安电子科技大学 技术物理学院 院长</td></tr>
                      <tr>
                        <td valign="top" align="left"><strong>马&nbsp;&nbsp;&nbsp;&nbsp;力</strong></td>
                        <td valign="top" align="left">西安邮电学院 教授</td></tr>
                      <tr>
                        <td valign="top" align="left"><strong>尹 树 华</strong></td>
                        <td valign="top" align="left">西安通信学院 教授</td></tr>
                      <tr>
                        <td valign="top" align="left"><strong>巨 永 峰</strong></td>
                        <td valign="top" align="left">长安大学自控学院 院长</td></tr>
                      <tr>
                        <td valign="top" align="left"><strong>王 亚 平</strong></td>
                        <td valign="top" align="left">西安电子科技大学 副教授</td></tr>
                      <tr>
                        <td valign="top" align="left"  ><strong>王 兴 亮</strong></td>
                        <td valign="top" align="left"  >西安空军工程大学 教授</td></tr>
                      <tr>
                        <td valign="top" align="left"  ><strong>王 振 荣</strong></td>
                        <td valign="top" align="left"  >陕西省电子产品监督检验所 所长</td></tr>
                      <tr>
                        <td valign="top" align="left"  ><strong>田 来 科</strong></td>
                        <td valign="top" align="left"  >西北大学 教授</td></tr>
                      <tr>
                        <td valign="top" align="left"  ><strong>刘 书 明</strong></td>
                        <td valign="top" align="left"  >西安电子科技大学 教授</td></tr>
                      <tr>
                        <td valign="top" align="left"  ><strong>向&nbsp;&nbsp;&nbsp;&nbsp;河</strong></td>
                        <td valign="top" align="left"  >西北工业大学 教授&nbsp; IEEE西安分会办公室主任</td></tr>
                      <tr>
                        <td valign="top" align="left"  ><strong>李&nbsp;&nbsp;&nbsp;&nbsp;刚</strong></td>
                        <td valign="top" align="left"  >天津大学 &nbsp;教授 博导</td></tr>
                      <tr>
                        <td valign="top" align="left"  ><strong>李&nbsp;&nbsp;&nbsp;&nbsp;鹏</strong></td>
                        <td valign="top" align="left"  >西安电子科技大学 教授</td></tr>
                      <tr>
                        <td valign="top" align="left"  ><strong>邢 相 禄</strong></td>
                        <td valign="top" align="left"  >陕西省电子学会 秘书长</td></tr>
                      <tr>
                        <td valign="top" align="left"  ><strong>邢 苗 条</strong></td>
                        <td valign="top" align="left"  >西安财经学院 计算机学院 副教授</td></tr>
                      <tr>
                        <td valign="top" align="left"  ><strong>周&nbsp;&nbsp;&nbsp;&nbsp;端</strong></td>
                        <td valign="top" align="left"  >西安电子科技大学 教授</td></tr>
                      <tr>
                        <td valign="top" align="left"  ><strong>周 志 宇</strong></td>
                        <td valign="top" align="left"  >浙江理工大学 副教授</td></tr>
                      <tr>
                        <td valign="top" align="left"  ><strong>陆&nbsp;&nbsp;&nbsp;&nbsp;原</strong></td>
                        <td valign="top" align="left"  >河北大学电子信息工程学院 教授</td></tr>
                      <tr>
                        <td valign="top" align="left"  ><strong>赵 祥 模</strong></td>
                        <td valign="top" align="left"  >长安大学信息学院 教授</td></tr>
                      <tr>
                        <td valign="top" align="left"  ><strong>郝 迎 吉</strong></td>
                        <td valign="top" align="left"  >西安科技大学电子机械学院 教授</td></tr>
                      <tr>
                        <td valign="top" align="left"  ><strong>夏 景 波</strong></td>
                        <td valign="top" align="left"  >西安空军工程大学 教授</td></tr>
                      <tr>
                        <td valign="top" align="left"  ><strong>雷 景 生</strong></td>
                        <td valign="top" align="left"  >海南大学信息科学技术学院 副院长</td></tr>
                      <tr>
                        <td valign="top" align="left"  ><strong>谭 宝 成</strong></td>
                        <td valign="top" align="left"  >西安工业大学 教授</td></tr>
                      <tr>
                        <td valign="top" align="left"  ><strong>熊 剑 平</strong></td>
                        <td valign="top" align="left"  >北京清华大学 教授</td></tr>
                      <tr>
                        <td valign="top" align="left"  ><strong>何&nbsp;&nbsp;&nbsp;&nbsp;一</strong></td>
                        <td valign="top" align="left"  >西安通信学院 博士</td></tr>
                      <tr>
                        <td valign="top" align="left"  ><strong>白 振 兴</strong></td>
                        <td valign="top" align="left"  >西安空军工程学院&nbsp; 教授</td></tr>
                      <tr>
                        <td valign="top" align="left"  ><strong>张 冀 红</strong></td>
                        <td valign="top" align="left"  >新疆乌鲁木齐市计算机协会 秘书长 高级工程师</td></tr>
                      <tr>
                        <td valign="top" align="left"  ><strong>李 治 远</strong></td>
                        <td valign="top" align="left"  >西安国营877厂 总经理</td></tr>
                      <tr>
                        <td valign="top" align="left"  ><strong>司 存 瑞</strong></td>
                        <td valign="top" align="left"  >陕西教育学院 教授</td></tr>
                      <tr>
                        <td valign="top" align="left"  ><strong>李 国 民</strong></td>
                        <td valign="top" align="left"  >西安科技大学通信与信息工程学院 院长</td></tr>
                      <tr>
                        <td valign="top" align="left"  ><strong>柏 永 林</strong></td>
                        <td valign="top" align="left"  >西安英泰学院 院长</td></tr>
                      <tr>
                        <td valign="top" align="left"  ><strong>王 双 平</strong></td>
                        <td valign="top" align="left"  >中国电子科技集团公司第39研究所 总工程师 </td></tr>
                      <tr>
                        <td valign="top" align="left"  ><strong>李 伟 华</strong></td>
                        <td valign="top" align="left"  >西北工业大学 教授 </td></tr>
                      <tr>
                        <td valign="top" align="left"  ><strong>姚 伟 华</strong></td>
                        <td valign="top" align="left"  >陕西省电子产品检验所  总工程师</td></tr>
                      <tr>
                        <td valign="top" align="left"  ><strong>张 志 勇</strong></td>
                        <td valign="top" align="left"  >河南科技大学   教授</td></tr>
                      <tr>
                        <td valign="top" align="left"  ><strong>李 文 正</strong></td>
                        <td valign="top" align="left"  >北京工业大学软件学院 教授</td></tr></tbody></table>
                    <div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        Ishtml:true,
        activeNames: []
      }
    },
    components: {},
    methods: {

    }
  }
</script>

<style scoped>
table tr td,table tr th{ border: 1px #ddd solid; padding:10px;}
</style>
